















































import {
  computed,
  defineComponent,
  ref,
  Ref,
  toRefs,
  watch
} from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { useClassifiedForm } from '~/compositions/form'
import { Option } from '~/models/shared/types'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'

export default defineComponent({
  components: { CFormError },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const selectedCountry = ref<number | null>(null)
    const selectedRegion = ref<number | null>(null)
    const selectedSubRegion = ref<number | null>(null)
    const selectedNeighborhood = ref<number | null>(null)

    const subLocations = computed(() => specs.value?.locations || [])
    const countriesOptions = computed<Option[]>(() =>
      mapLocationsToOptions(
        (subLocations.value.length && subLocations.value[0]) || []
      )
    )
    const regionOptions = computed<Option[]>(() =>
      mapLocationsToOptions(
        (subLocations.value.length && subLocations.value[1]) || []
      )
    )
    const subRegionOptions = computed<Option[]>(() =>
      mapLocationsToOptions(
        (subLocations.value.length && subLocations.value[2]) || []
      )
    )
    const neighbourhoodOptions = computed<Option[]>(() =>
      mapLocationsToOptions(
        (subLocations.value.length && subLocations.value[3]) || []
      )
    )
    function mapLocationsToOptions(locations: any[]) {
      return locations.map((l: any) => ({
        text: l.human_name,
        value: l.id
      }))
    }

    function onValue(v: Ref<any>) {
      if (v.value && v.value.length) {
        const values = Array.from(v.value).reverse() as number[]
        const [country, region, subRegion, neighborhood] = values
        selectedCountry.value = country || null
        selectedRegion.value = region || null
        selectedSubRegion.value = subRegion || null
        selectedNeighborhood.value = neighborhood || null
      }
    }
    const { valueChanged, error } = useClassifiedForm(props, { onValue })

    watch(subLocations, newSubLocations => {
      if (!newSubLocations.length) {
        return
      }

      selectedCountry.value = getSelected(newSubLocations[0])
      selectedRegion.value = getSelected(newSubLocations[1])
      selectedSubRegion.value = getSelected(newSubLocations[2])
      selectedNeighborhood.value = getSelected(newSubLocations[3])
    })

    function getSelected(subLocationsOptions: any[]) {
      return (
        (subLocationsOptions || []).find((l: any) => l.selected)?.id || null
      )
    }

    function handleSubLocationInput(areaId: number) {
      valueChanged(name.value, areaId)
    }

    return {
      countriesOptions,
      regionOptions,
      subRegionOptions,
      neighbourhoodOptions,
      handleSubLocationInput,
      selectedCountry,
      selectedRegion,
      selectedSubRegion,
      selectedNeighborhood,
      error
    }
  }
})
